import React from "react";
import {InputNumber} from "primereact/inputnumber";
import {Divider} from "primereact/divider";

const KPITargetAnnual = ({formik, disabled}) => {
    const handleChange = e => {
        if(formik.values.timeFrame === 'Quarter') {
            if(formik.values.quarter === 'Q1') {
                formik.setFieldValue("targets[0]", e.value, false);
            }
            else if(formik.values.quarter === 'Q2') {
                formik.setFieldValue("targets[1]", e.value, false);
            }
            else if(formik.values.quarter === 'Q3') {
                formik.setFieldValue("targets[2]", e.value, false);
            }
            else if(formik.values.quarter === 'Q4') {
                formik.setFieldValue("targets[3]", e.value, false);
            }
        }

        if(formik.values.timeFrame !== 'Annual') {
            formik.handleChange(e);

            return;
        }

        if(e?.target?.id === 'targetValue') {
            const quarterValue = (formik.values?.type === 'Target') ? e.value / 4 : e.value;

            formik.setFieldValue("targets[0]", quarterValue, false);
            formik.setFieldValue("targets[1]", quarterValue, false);
            formik.setFieldValue("targets[2]", quarterValue, false);
            formik.setFieldValue("targets[3]", quarterValue, false);
        }
        else {
            let annual = 0;

            if(formik.values?.type === 'Target') {
                annual += e?.target?.id === 'targets[0]' ? (e.value || 0) : (formik.values?.targets[0] || 0);
                annual += e?.target?.id === 'targets[1]' ? (e.value || 0) : (formik.values?.targets[1] || 0);
                annual += e?.target?.id === 'targets[2]' ? (e.value || 0) : (formik.values?.targets[2] || 0);
                annual += e?.target?.id === 'targets[3]' ? (e.value || 0) : (formik.values?.targets[3] || 0);

                formik.setFieldValue("targetValue", annual, false);
            }
            else if(e?.target?.id === 'targets[3]') {
                formik.setFieldValue("targetValue", (e.value || 0), false);
            }
        }

        formik.handleChange(e);

        return;
    }

    const renderTargetInput = (id, value, type) => {
        if(type === 'DollarAmount') {
            return (<InputNumber id={id} name={id} className="inputfield w-4" value={value} onValueChange={handleChange} mode="currency" currency="USD" locale="en-US"  disabled={disabled}/>);
        }
        else if(type === 'Percent') {
            return (<InputNumber id={id} name={id} className="inputfield w-4" value={value} onValueChange={handleChange} maxFractionDigits={2} prefix="%" disabled={disabled}/>);
        }
        else {
            return (<InputNumber id={id} name={id} className="inputfield w-4" value={value} onValueChange={handleChange} maxFractionDigits={2} disabled={disabled}/>);
        }
    }

    if(formik.values?.type !== 'Benchmark' && formik.values?.type !== 'Target') {
        return (<></>);
    }

    const renderTargetValue = () => {
        return (
            <>
                <div className="field col-12">
                    <span className="p-float-label">
                        {renderTargetInput("targetValue", formik.values?.targetValue, formik.values?.valueType)}
                        <label htmlFor="targetValue">{formik.values?.type} Value</label>
                    </span>
                </div>
            </>
        )
    }

    const renderQuarters = () => {
        return (
            <>
                {renderTargetValue()}
                <div className="field col-12">
                    <span className="p-float-label">
                        {renderTargetInput("targets[0]", formik.values?.targets[0], formik.values?.valueType)}
                        <label htmlFor="targets[0]">Q1 {formik.values?.type}</label>
                    </span>
                </div>
                <div className="field col-12">
                    <span className="p-float-label">
                        {renderTargetInput("targets[1]", formik.values?.targets[1], formik.values?.valueType)}
                        <label htmlFor="targets[1]">Q2 {formik.values?.type}</label>
                    </span>
                </div>
                <div className="field col-12">
                    <span className="p-float-label">
                        {renderTargetInput("targets[2]", formik.values?.targets[2], formik.values?.valueType)}
                        <label htmlFor="targets[2]">Q3 {formik.values?.type}</label>
                    </span>
                </div>
                <div className="field col-12">
                    <span className="p-float-label">
                        {renderTargetInput("targets[3]", formik.values?.targets[3], formik.values?.valueType)}
                        <label htmlFor="targets[3]">Q4 {formik.values?.type}</label>
                    </span>
                </div>
            </>
        )
    }

    return (
        <>
            <Divider />
            <div className="field col-12">
                    <span className="p-float-label">
                        <InputNumber id="weight" name="weight" className="inputfield w-4" value={formik.values?.weight} onValueChange={formik.handleChange} disabled={disabled}/>
                        <label htmlFor="weight">Weight</label>
                    </span>
            </div>
            {formik.values.timeFrame === 'Annual' ? renderQuarters() : renderTargetValue()}
        </>
    );
}

export default KPITargetAnnual;